import { useEffect } from "react";
import { useBreadcrumbs } from "../../contexts/breadcrumb";
import GroupIcon from "@material-ui/icons/Group";
import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useUsersStyles } from "./styles";
import UsersActions from "./components/Actions";
import { useUsersList } from "../../services/api-tansquery/user/list";
import EmptyState from "../../Components/EmptyState";
import CustomPagination from "../../Components/pagination";
import SearchField from "./components/search-field";
import { dateformat } from "../../utils/dateFormat";

export default function Users() {
  const { data: usersList } = useUsersList();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { classes } = useUsersStyles();

  useEffect(() => {
    setBreadcrumbs((prev) => {
      const homeBreadcrumb = prev.find((_, index) => index === 0);
      return [
        homeBreadcrumb,
        {
          label: "Usuários",
          path: "/usuarios",
          icon: GroupIcon,
        },
      ];
    });
  }, [setBreadcrumbs]);

  const isEmptyList = (usersList?.results ?? []).length === 0;

  return (
    <Box>
      <Box className={classes.header}>
        <Typography className={classes.title}>Usuários</Typography>
      </Box>
      <Paper elevation={3}>
        <SearchField placeholder="Buscar por nome ou CPF..." />
        <TableContainer className={classes.tableContainer}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableTH}>Nome</TableCell>
                <TableCell className={classes.tableTH}>CPF</TableCell>
                <TableCell className={classes.tableTH}>Órgão(s)</TableCell>
                <TableCell className={classes.tableTH}>Último Login</TableCell>
                <TableCell className={classes.tableTH} />
              </TableRow>
            </TableHead>
            <TableBody>
              {usersList?.results.map((user) => (
                <TableRow key={user.id}>
                  <TableCell className={classes.tableCell}>
                    {user.first_name}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {user.username}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <Box className={classes.chipsBox}>
                      {user.orgaos && user.orgaos.length > 0 ? (
                        Array.from(new Map(user.orgaos.map(item => [item.orgao.id, item])).values()).map((orgaoData, index) => (
                          <Chip
                            key={`${user.id}-${orgaoData.orgao.id}-${index}`}
                            label={orgaoData.orgao.sigla}
                          />
                        ))
                      ) : (
                        <Typography variant="body2" color="textSecondary">
                          Nenhum órgão vinculado
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {dateformat(user.last_login, true) || "Não informado"}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <UsersActions id={user.id} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {isEmptyList && <EmptyState message="Nenhum usuário encontrado." />}
        </TableContainer>
        <Box className={classes.paginationContainer}>
          <CustomPagination
            count={usersList?.count}
            page={usersList?.current}
            totalPages={usersList?.total_pages}
          />
        </Box>
      </Paper>
    </Box>
  );
}
